import React from "react";
import {
  Drawer,
  List,
  Toolbar,
  useTheme,
  Box,
  useMediaQuery,
  Button,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import NavItem from "./SidebarNavItem";
import {
  Home as HomeIcon,
} from "@mui/icons-material";

const drawerWidth = 240;

const guestNavItems = [
  { text: "TN", icon: <HomeIcon />, path: "/guest" },
];

type GuestSidebarProps = {
  open: boolean;
  handleClose: () => void;
  toggleDrawer?: any;
};

const GuestSidebar = ({
  open,
  handleClose,
  toggleDrawer,
}: GuestSidebarProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavigation = (path: string) => {
    navigate(path);
    if (isMobile) {
      handleClose();
    }
  };

  return (
    <Drawer
      variant={isMobile ? "temporary" : "permanent"}
      open={open}
      onClose={handleClose}
      sx={{
        width: open ? drawerWidth : 72,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: open ? drawerWidth : 72,
          transition: "width 0.3s ease",
          backgroundColor: "#FAFAFF",
          borderRight: "1px solid #E4E4E7",
          overflowX: "hidden",
          boxSizing: "border-box",
          px: open ? 1.5 : 0,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          fontFamily: '"Lexend", sans-serif',
          boxShadow: "2px 0 6px rgba(0, 0, 0, 0.04)",
        },
      }}
    >
      <Box>
        <Toolbar />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1.5,
            pt: 3,
            fontFamily: '"Lexend", sans-serif',
          }}
        >
          <List
            disablePadding
            sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}
          >
            {guestNavItems.map((item) => (
              <NavItem
                key={item.text}
                item={item}
                open={open}
                selected={location.pathname === item.path}
                onClick={isMobile ? handleClose : undefined}
              />
            ))}
          </List>
        </Box>
      </Box>

      {/* Mobile Auth Buttons */}
      {isMobile && (
        <Box sx={{ p: 2, borderTop: "1px solid #E4E4E7" }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <Button
              fullWidth
              onClick={() => handleNavigation("/sign-in")}
              sx={{
                fontWeight: 600,
                color: "#6366F1",
                textTransform: "none",
                fontFamily: '"Lexend", sans-serif',
                border: "1px solid #6366F1",
                borderRadius: "8px",
                py: 1,
                "&:hover": {
                  backgroundColor: "#f0f4ff",
                },
              }}
            >
              Login
            </Button>
            <Button
              fullWidth
              variant="contained"
              onClick={() => handleNavigation("/register")}
              sx={{
                background: "linear-gradient(135deg, #9F03FF 0%, #6366F1 100%)",
                color: "#fff",
                fontWeight: 600,
                textTransform: "none",
                fontFamily: '"Lexend", sans-serif',
                borderRadius: "8px",
                py: 1,
                "&:hover": {
                  background:
                    "linear-gradient(135deg, #7c00cc 0%, #5855EB 100%)",
                },
              }}
            >
              Sign Up
            </Button>
          </Box>
        </Box>
      )}
    </Drawer>
  );
};

export default GuestSidebar;
